import { useLesson } from '.';
import { useAssetTimeRemaining } from '../userProgress';
export const useLessonProgressTime = lessonId => {
  const {
    lesson,
    lessonLoading
  } = useLesson(lessonId);
  const totalTime = lesson && lesson.duration;
  const {
    remainingTime,
    allProgressLoading
  } = useAssetTimeRemaining({
    id: lessonId,
    type: 'LESSON',
    contentIds: lesson && lesson.contentIds && lesson.contentIds.map(id => Number(id)),
    totalTime
  });
  return {
    remainingTime,
    totalTime,
    lessonProgressTimeLoading: lessonLoading || allProgressLoading
  };
};